<!-- MFA sign-in code entry view -->
<section class="form-group" [ngClass]="{ 'd-none': loading }">
  <article [ngClass]="theme.getThemeClass()" class="wrapper fadeInDown">
    <div [ngClass]="theme.getThemeClass()" id="formContent">
      <!-- ICON -->
      <nav class="fadeIn first">
        <img class="logo" src="../assets/muirwood-studio.png" />
      </nav>
      <div>
        <h3>{{ "enterMFACode" | translate }}</h3>
      </div>
      <!-- LOGIN FORM -->
      <form (ngSubmit)="ctx.MFASignIn()">
        <div [ngClass]="theme.getThemeClass()" class="form-group">
          <div class="fadeIn second">
            <input
              id="MFACode"
              type="text"
              [(ngModel)]="ctx.MFACode"
              class="form-control"
              name="MFACode"
              placeholder="{{ 'MFACode' | translate }}"
              required
              autocomplete="off"
            />
          </div>
        </div>
        <input
          type="submit"
          skipLocationChange
          class="fadeIn fourth"
          value="{{ 'cognitoLoginBtnLogIn' | translate }}"
          height="30px"
        />
      </form>
    </div>
  </article>
</section>
